import React from 'react';
import * as cls from './amazon-shop.module.css';
import { EasyInstallation } from './easy-installation';
import { HowItWorks } from './how-it-works';
import { KeyBenefits } from './key-benefits';
import { Reviews } from './reviews';
import { WhyVoltaware } from './why-voltaware';
import Meta from '../../../components/meta';
import { FAQ } from '../../ui/layouts/faq';
import { SmarterWay } from './smarter-way';
import { StartSavingNow } from './start-saving-now/start-saving-now';
import { IMG_PATH } from '../../constants';
import {
  Typography,
  TypographyHighlight,
} from '../../ui/components/typography';

const url1 =
  'https://www.amazon.co.uk/dp/B0CLVBSZ4Y?maas=maas_adg_2B26FDBF5288600D1629844AE699A2DA_afap_abs&ref_=aa_maas&tag=maas&utm_source=lp2&utm_medium=website&utm_term=button1';
const url2 =
  'https://www.amazon.co.uk/dp/B0CLVBSZ4Y?maas=maas_adg_2B26FDBF5288600D1629844AE699A2DA_afap_abs&ref_=aa_maas&tag=maas&utm_source=lp2&utm_medium=website&utm_term=button2';
const url3 =
  'https://www.amazon.co.uk/dp/B0CLVBSZ4Y?maas=maas_adg_2B26FDBF5288600D1629844AE699A2DA_afap_abs&ref_=aa_maas&tag=maas&utm_source=lp2&utm_medium=website&utm_term=button3';
const url4 =
  'https://www.amazon.co.uk/dp/B0CLVBSZ4Y?maas=maas_adg_2B26FDBF5288600D1629844AE699A2DA_afap_abs&ref_=aa_maas&tag=maas&utm_source=lp2&utm_medium=website&utm_term=button4';
// const irelandURL = 'https://www.amazon.ie/dp/B0CLVBSZ4Y';

const faqs = [
  {
    question: 'Do I need a smart meter?',
    answer: 'No. Voltaware works with or without one.',
  },
  {
    question: 'Who should install it?',
    answer: 'A qualified electrician; typical install ~5 minutes.',
  },
  {
    question: 'Will it name every device?',
    answer:
      'It identifies major appliance signatures and gives useful estimates; some small or similar loads may be grouped.',
  },
  {
    question: 'Can it help reduce bills?',
    answer:
      'Yes, by revealing waste and giving actionable tips (results vary by home and habits).',
  },
  {
    question: 'Is my data private?',
    answer: 'Yes, privacy by design with GDPR principles.',
  },
];

export const V2AmazonShop = () => {
  return (
    <>
      <Meta
        title="Buy a Smart Energy Monitor for Your Home | Voltaware"
        description="Shop Voltaware’s smart energy monitor to track real-time electricity use. Easy setup, clear savings. Free delivery across the UK."
      />

      <section className={cls.hero}>
        <div>
          <img alt="" src={`${IMG_PATH}/amazon-shop/banner.png`} />
          <div className={cls.heroContent}>
            <Typography tag="h1">Smart Energy Monitor for Your Home</Typography>
            <Typography className={cls.heroContentText}>
              for
              <TypographyHighlight>£149</TypographyHighlight>
              on Amazon
            </Typography>
            <Typography className={cls.heroContentPolicy}>
              Prime delivery and Amazon returns
            </Typography>
            <a href={url1} rel="noopener noreferrer" target="_blank">
              <img
                alt="Order Now on Amazon"
                src={`${IMG_PATH}/amazon-shop/order-now-on-amazon.png`}
              />
            </a>
          </div>
        </div>
      </section>

      <KeyBenefits />
      <HowItWorks />
      <EasyInstallation url={url2} />
      <WhyVoltaware />
      <Reviews url={url3} />
      <FAQ customFaqs={faqs} shouldAnimate={false} />
      <SmarterWay />
      <StartSavingNow url={url4} />
    </>
  );
};
